export default __webpack_public_path__ + "static/media/appStore.a82087e5.svg";